import React, { useState, useEffect, forwardRef, useMemo, useRef} from 'react';
import { socket } from './../../socket';

import AppContext from "./../../app-context"
import closeOnClickOutside from './../../components/core/close-on-click-outside'
import RenderFormFields from './forms'
import {useAuth} from "../../AuthContext";

const getInitialLang = () => (localStorage.getItem("lang") || "en").toLowerCase();

const dict = {
    en: {
        search: "Search",
        actions: "Actions",
        emptyItems: "Empty items",
        rowsPerPage: "Rows per page:",
        rangeOf: "of",
        loading: "Loading...",
    },
    ru: {
        search: "Поиск",
        actions: "Действия",
        emptyItems: "Нет данных",
        rowsPerPage: "Строк на странице:",
        rangeOf: "из",
        loading: "Загрузка...",
    },
    ua: {
        search: "Пошук",
        actions: "Дії",
        emptyItems: "Немає даних",
        rowsPerPage: "Рядків на сторінці:",
        rangeOf: "з",
        loading: "Завантаження...",
    },
};

const ActionsDropDownWrappedOLD = forwardRef((props, ref) => {
    const {open, setOpen} = props

    var className = "btn btn-light dropdown-toggle"
    var actionClassName = "dropdown-menu"

    if(open){
        className = "btn btn-light dropdown-toggle show"
        actionClassName = "dropdown-menu show"
    }

    const handleOpenActions = () => {
        setOpen(open ? 0 : 1)
    }

    const actions = props.actions || []
    const tableAction = props.tableAction || null

    const title = props.title || ""


    const visibleActions = (actions || []).filter((item) => {
        if (typeof item.fn === "function") {
            return item.fn(item.name, props.data);
        }
        return true;
    });

    if (!visibleActions.length) {
        return <span className="text-muted">-</span>;
    }

    return (
        <div className="dropdown position-static">
            <button
                className={className}
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                data-bs-display="static"
                aria-expanded={open ? "true" : "false"}
                onClick={handleOpenActions}>
                {title} <i className="ti ti-dots-vertical"></i>
            </button>
            <ul className={actionClassName} aria-labelledby="dropdownMenuButton" ref={ref}>
                {visibleActions.map((item) => (
                    <li key={item.name}>
                        <a className="dropdown-item" href="javascript:void(0)" onClick={() => {
                            setOpen(0)
                            if (tableAction !== null){
                                tableAction(item.name, props.data || {})
                            }
                        }}>{item.label}</a>
                    </li>
                ))}
            </ul>
        </div>
    )
});



const ActionsDropDownWrapped = ({ actions = [], tableAction, title = "", data }) => {
    const visibleActions = actions.filter((item) => !item.fn || item.fn(item.name, data));

    return (
        <div className="dropdown position-static">
            <button
                className="btn btn-light dropdown-toggle"
                type="button"
                id={`drop-${data?.id || Math.random()}`}
                data-bs-toggle="dropdown"
                data-bs-display="static"
                data-bs-boundary="viewport"
                aria-expanded="false"
            >
                {title} <i className="ti ti-dots-vertical" />
            </button>

            <ul className="dropdown-menu" aria-labelledby={`drop-${data?.id || ""}`}>
                {visibleActions.length === 0 ? (
                    <li>
                        <span className="dropdown-item text-muted small">
                            {title ? `${title}: No actions` : "No actions"}
                        </span>
                    </li>
                ) : (
                    visibleActions.map((item) => (
                        <li key={item.name}>
                            <a
                                className="dropdown-item"
                                href="javascript:void(0)"
                                onClick={() => tableAction?.(item.name, data || {})}
                            >
                                {item.label}
                            </a>
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
};

const ActionsDropDown =  closeOnClickOutside(ActionsDropDownWrappedOLD)

const DefaultCard = ({ item, columns, actionsRenderer }) => {
    return (
        <div className="card h-100 shadow-sm border">
            <div className="card-body d-flex flex-column">
                {columns.map((col) => (
                    <div key={col.key} className="mb-2">
                        <div className="text-muted text-uppercase fw-semibold fs-2 mb-1">{col.label}</div>
                        <div className="fw-semibold">
                            {col.format ? col.format(item, col.key) : (item[col.key] ?? "-")}
                        </div>
                    </div>
                ))}
                {actionsRenderer && (
                    <div className="mt-auto d-flex justify-content-end pt-3">
                        {actionsRenderer()}
                    </div>
                )}
            </div>
        </div>
    );
};

const DrowRow = (props) => {
    //const itemsCount = props.itemsCount

    const actions = props.actions || []
    const tableAction = props.tableAction || null

    const handleChange = (itemID) => {
        //selectedItems={selectedItems}, setSelectedItems={setSelectedItems}
        //props.selectedItems["item_0"]
        console.log("checkbox - ", !props.selectedItems[`item_${itemID}`])

        let choosedItems = {...props.selectedItems}
        choosedItems[`item_${itemID}`] = !props.selectedItems[`item_${itemID}`]

        console.log("checkboxes : ", choosedItems)
        props.setSelectedItems(choosedItems)
    }

    return (
        <tr>
            {!props.hideGroupActions && props.data && props.data['id'] ? (
                <td>
                    <div className="form-check mb-0">
                        <input className="form-check-input"
                               type="checkbox"
                               checked={props.selectedItems[`item_${props.data['id']}`] || 0}
                               onChange={() => handleChange(props.data['id'])} />
                    </div>
                </td>
            ): null}

            {props.data ?
                props.columns.map((item, index) => {
                    return props.data[item.key] || item.format ? <td>{item.format ? item.format(props.data, item.key) : props.data[item.key]}</td> : <td> - </td>
                }) : <td colspan={props.columns.length + 2}>{props.text ? props.text : " - "}</td>}

            {!props.hideActions && props.data && props.data['id'] ? (
                <td>
                    <ActionsDropDown data={props.data} actions={actions} tableAction={tableAction} />
                </td>
            ): null}
        </tr>
    )
}

const DrowColumns = (props) => {
    const handleChange = () => {
       //selectedItems={selectedItems}, setSelectedItems={setSelectedItems}
       //props.selectedItems["item_0"]
        //console.log("checkbox - ", !props.selectedItems["item_0"])

       /*
       props.data.data && props.data.data.length > 0 ? props.data.data.map((item, index) => {
                                    if(index >= itemsCount) return null;
       * */
       let choosedItems = null
       if(props.selectedItems){
           choosedItems =  {item_0: !props.selectedItems["item_0"]}
           if (!props.selectedItems["item_0"] && props.data.data && props.data.data.length > 0 ){
               props.data.data.forEach((item, index) => {
                   if(index >= props.itemsCount) return null;
                   choosedItems[`item_${item.id}`] = true
               })
           }
           console.log("checkboxes : ", choosedItems)
           props.setSelectedItems(choosedItems)
       }
    }
    return (
        <tr>
            {props.selectedItems && !props.hideGroupActions && <th scope="col" style={{width: "80px"}}>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox"
                           checked={props.selectedItems["item_0"] || 0}
                           onChange={handleChange} />
                </div>
            </th>}
            {props.columns.map(item => { return <th scope="col" style={{width: item.width}}>{item.label}</th>})}
            {!props.hideActions && <th scope="col" style={{width: "100px"}}>Actions</th>}
        </tr>
    )
}

const AddContactButton = ({ addFunction, addTitle, disable, style = {}, wrapperStyle = {} }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipTimeout = useRef(null);
    const isDisabled = disable?.add?.disable;
    const tooltipText = disable?.add?.title;

    // Handle tooltip show with delay
    const handleMouseEnter = () => {
        if (isDisabled) {
            tooltipTimeout.current = setTimeout(() => setShowTooltip(true), 500); // Show after 500ms
        }
    };

    // Handle tooltip hide with delay
    const handleMouseLeave = () => {
        clearTimeout(tooltipTimeout.current);
        tooltipTimeout.current = setTimeout(() => setShowTooltip(false), 300); // Hide after 300ms
    };

    return (
        <div
            className="relative inline-block"
            style={{
                height: wrapperStyle.height || "auto",
                zIndex: isDisabled ? "100000" : "0",
                display: wrapperStyle.display || "flex",
                alignItems: wrapperStyle.alignItems || "flex-end",
                width: wrapperStyle.width || "auto",
                paddingTop: wrapperStyle.paddingTop || 0,
                paddingBottom: wrapperStyle.paddingBottom || 0,
                ...wrapperStyle,
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {/* Button */}
            <button
                id="btn-add-contact"
                style={{
                    cursor: isDisabled ? "help" : "pointer",
                    marginBottom: typeof style.marginBottom === "undefined" ? 32 : style.marginBottom,
                    ...style,
                }}
                className={`btn btn-primary d-flex align-items-center px-4 py-2 rounded-md ${
                    isDisabled ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
                }`}
                onClick={!isDisabled ? addFunction : undefined}
                disabled={isDisabled}
            >
                <i className="ti ti-users text-white me-1 fs-5"></i> {addTitle}
            </button>

            {isDisabled && (
                <div
                    style={{
                        textAlign: "left",
                        position: "absolute",
                        left: "50%",
                        top: "100%",
                        transform: "translateX(-50%)",
                        minWidth: "220px",
                        maxWidth: "260px",
                        pointerEvents: "none",
                    }}
                    className={`p-3 text-sm text-white bg-dark rounded shadow-lg transition-opacity duration-200 ${
                        showTooltip ? "opacity-100 visible" : "opacity-0 invisible"
                    }`}
                >
                    {tooltipText}
                </div>
            )}
        </div>
    );
};

const Table = (props) => {
    const { user } = useAuth();

    const lang = (props.lang || getInitialLang());
    const t = useMemo(() => dict[lang] || dict.en, [lang]);

    //const [pageNum, setPageNum] = useState(AppContext.pages && AppContext.pages[props.object] && AppContext.pages[props.object].pageNum || 1)
    const [itemsCount, setItemsCount] = useState(AppContext.rows_per_page)

    const [fieldsData, setFieldsData] = useState(JSON.parse(localStorage.getItem(`${props.object}_search`)) || {})
    const [response, setResponse] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const hasLoadedRef = useRef(false);
    const loaderTimerRef = useRef(null);

    async function fieldsChange(event, key, item_id=null){
        var data = {...fieldsData}
        if(item_id == null) {
            data = {...data, [key]: event.target.value}
        }else{
            //console.log("push ::: ", data, key)
            if (!data[key]) data[key] = []
            if(data[key].includes(item_id)){
                data[key] = data[key].filter(e => e !== item_id)
            }else{
                data[key].push(item_id)
            }

        }

        setFieldsData(data)

        return data
        //console.log("fields data::::", fieldsData)
    }

    //function fieldsChange(event, key){
    //    setFieldsData({...fieldsData, [key]: event.target.value})
    //}

    const itemsCountPerTable = [5,10,25]
    const itemsCountNumber = Number(itemsCount) || itemsCountPerTable[0]

    var fromRowsCount = (props.pageNum-1) * itemsCountNumber + 1
    var toRowsCount = props.pageNum * itemsCountNumber
    if(toRowsCount > props.data.rowsCount) toRowsCount = props.data.rowsCount

    const actions = props.actions || []
    const tableAction = props.tableAction || null

    const multiActions = props.multiActions || []

    // убираем лоадер после первой загрузки данных (даже если пустой массив, но ответ получен)
    useEffect(() => {
        if (!hasLoadedRef.current && props.data !== undefined) {
            hasLoadedRef.current = true;
            setIsLoading(false);
        }
    }, [props.data]);

    // защищаем от мерцаний: показываем оверлей только если загрузка длится дольше короткой задержки
    useEffect(() => {
        if (isLoading) {
            loaderTimerRef.current = setTimeout(() => setShowLoader(true), 180);
        } else {
            clearTimeout(loaderTimerRef.current);
            setShowLoader(false);
        }

        return () => clearTimeout(loaderTimerRef.current);
    }, [isLoading]);

    const search = (event) => {
        if(event.key === "Enter"){
            hasLoadedRef.current = false;
            setIsLoading(true);

            let data = event.data || fieldsData
            const page = event.page || 1

            const items_count = event.items_count || itemsCountNumber
            //if (!props.disableSaveFilters) {
            AppContext.pages[props.object] = {...AppContext.pages[props.object], pageNum: page}
            //}

            //props.setResponse({})
            props.setSelectedItems({})
            props.setPageNum(page)


            //return

            const args = props.args || {}/*simple_search_text: props.searchData*/

            let searchData = {}
            let saveSearchData = {...data}

            Object.keys(data).forEach((field) => {
                let propName = `simple_search_${field}`
                searchData = {...searchData, [propName]: data[field]}
            })

            const resData = {token: user.token, page: page, items_count: items_count, ...searchData, ...props.filters, ...args}

            socket.emit(`${props.object}:list`, resData);

            if (!props.disableSaveFilters) {
                localStorage.setItem(`${props.object}_search`, JSON.stringify(saveSearchData))
            }

            localStorage.setItem(`${props.object}_settings`, JSON.stringify(saveSearchData))
        }
    }


    const getIsDesktop = () => {
        if (typeof window === "undefined") return true;
        return window.innerWidth >= 1200;
    };

    const [isDesktop, setIsDesktop] = useState(getIsDesktop);
    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 1200);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const availableViewModes = !isDesktop
        ? (props.viewModes && props.viewModes.includes("blocks") ? ["blocks"] : ["blocks"])
        : (props.viewModes && props.viewModes.length ? props.viewModes : ["table"]);

    const resolveDefaultViewMode = () => {
        if (!isDesktop) return "blocks";
        if (props.defaultViewMode && availableViewModes.includes(props.defaultViewMode)) {
            return props.defaultViewMode;
        }
        return availableViewModes[0];
    };

    const getInitialViewMode = () => {
        const defaultMode = resolveDefaultViewMode();
        if (!isDesktop || availableViewModes.length < 2) return defaultMode;
        const stored = localStorage.getItem(`${props.object}_view_mode`);
        return stored && availableViewModes.includes(stored) ? stored : defaultMode;
    };

    const [viewMode, setViewMode] = useState(getInitialViewMode);

    useEffect(() => {
        const defaultMode = resolveDefaultViewMode();
        if (!availableViewModes.includes(viewMode)) {
            setViewMode(defaultMode);
        }
    }, [availableViewModes.join(","), viewMode, isDesktop]);

    useEffect(() => {
        if (availableViewModes.length > 1 && isDesktop) {
            localStorage.setItem(`${props.object}_view_mode`, viewMode);
        }
    }, [viewMode, availableViewModes.length, props.object, isDesktop]);

    const handleViewModeChange = (mode) => {
        if (mode === viewMode || !availableViewModes.includes(mode)) return;
        setViewMode(mode);
    };

    const showViewToggle = availableViewModes.length > 1 && isDesktop;

    let width = 12
    if (props.addTitle) {
        width = 9
    }

    const defaultSearchFields = [
        {
            type: "tab",
            name: "",
            image: "",
            fields: [
                [
                    {
                        label: t.search, key: "text",
                        beforeField: <><i style={{top: "14px"}} className="ti ti-search position-absolute start-0 translate-middle-y fs-6 text-dark ms-3 relative"></i></>,
                        classField: "product-search ps-5",
                        styleField: { marginTop: "-20px" }
                    },
                ]
            ]
        },
    ]

    let searchFields = props.searchFields && props.searchFields.simple || defaultSearchFields

    const renderActions = (item) => {
        if (props.hideActions || !actions.length || !item?.id) return null;
        return <ActionsDropDown data={item} actions={actions} tableAction={tableAction} />;
    };

    const defaultCardRenderer = (item) => (
        <DefaultCard item={item} columns={props.columns} actionsRenderer={() => renderActions(item)} />
    );

    const cardRenderer = props.renderItem
        ? (item) => props.renderItem(item, { renderActions, actions, tableAction })
        : defaultCardRenderer;

    const cardColumnClass = props.cardLayout?.columnClass || "col-12 col-md-6 col-xl-4";
    const visibleItems = Array.isArray(props.data.data) ? props.data.data.slice(0, itemsCountNumber) : [];

    /*
    {props.simpleSearch ? <props.simpleSearch searchData={props.searchData} disableSaveFilters={props.disableSaveFilters} object={props.object} setSearchData={props.setSearchData} search={search} /> :
        <>
            <input type="text" className="form-control product-search ps-5" id="input-search"
                   placeholder="Search ..."
                   value={props.searchData} onChange={(event) => {
                if (!props.disableSaveFilters) {
                    localStorage.setItem(`${props.object}_simple_search_text`, event.target.value)
                }
                props.setSearchData(event.target.value)
            }} onKeyPress={search} />
            <i className="ti ti-search position-absolute top-50 start-0 translate-middle-y fs-6 text-dark ms-3"></i>
        </>
    }
    fieldsData1={fieldsData} fieldsChange1={fieldsChange} response1={response}
    */
    return (
        <>
            <div className="card card-body" style={{paddingBottom: "0px", paddingTop: "5px"}}>
                <div className="row g-3 align-items-stretch">
                    <div className={`col-12 col-xl-${width}`}>
                        <div className="position-relative h-100">
                            <RenderFormFields fields={searchFields} fieldsData={fieldsData} fieldsChange={fieldsChange} response={response} enterApply={search} hideBorders={true}/>
                        </div>
                    </div>
                    {props.addTitle && (
                        <div className={(props.addButtonWrapperClass || "col-12 col-xl-3 d-flex") + " mt-2 mt-xl-0"}>
                            <div className="w-100 h-100 d-flex justify-content-center justify-content-xl-end align-items-end">
                                <AddContactButton
                                    addFunction={props.addFunction}
                                    addTitle={props.addTitle}
                                    disable={props.disable}
                                    wrapperStyle={props.addButtonWrapperStyle}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showViewToggle && (
                <div className="d-flex justify-content-end gap-2 mt-3 mb-3">
                    <div className="btn-group" role="group" aria-label="View mode switcher">
                        <button
                            type="button"
                            className={`btn btn-outline-primary ${viewMode === "table" ? "active" : ""}`}
                            onClick={() => handleViewModeChange("table")}
                        >
                            <i className="ti ti-table"></i>
                        </button>
                        {availableViewModes.includes("blocks") && (
                            <button
                                type="button"
                                className={`btn btn-outline-primary ${viewMode === "blocks" ? "active" : ""}`}
                                onClick={() => handleViewModeChange("blocks")}
                            >
                                <i className="ti ti-layout-grid"></i>
                            </button>
                        )}
                    </div>
                </div>
            )}

            <div className="product-list">
                <div
                    className={`position-relative ${
                        viewMode === "blocks"
                            ? "card card-body"
                            : "card"
                    }`}
                    style={{ minHeight: "180px", padding: viewMode === "blocks" ? "0px" : undefined }}
                >
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{
                            background: "rgba(0, 0, 0, 0.35)",
                            zIndex: 10,
                            backdropFilter: "blur(2px)",
                            opacity: showLoader ? 1 : 0,
                            pointerEvents: showLoader ? "auto" : "none",
                            transition: "opacity 180ms ease",
                        }}
                    >
                        <div className="text-center text-white">
                            <div className="spinner-border text-light mb-3" role="status">
                                <span className="visually-hidden">{t.loading}</span>
                            </div>
                            <div className="fw-semibold">{t.loading}</div>
                        </div>
                    </div>
                    <div className="card-body" style={{ padding: viewMode === "blocks" ? 0 : undefined }}>
                        <div className={`table-responsive ${viewMode === "blocks" ? "" : "border rounded"}`}>
                            {viewMode === "table" && (
                                <table className="table align-middle text-nowrap mb-0">
                                    <thead>
                                    <DrowColumns
                                        hideActions={props.hideActions}
                                        hideGroupActions={props.hideGroupActions || false}
                                        columns={props.columns}
                                        selectedItems={props.selectedItems}
                                        setSelectedItems={props.setSelectedItems}
                                        itemsCount={itemsCountNumber}
                                        data={props.data}
                                        actionsTitle={t.actions}
                                    />
                                    </thead>
                                    <tbody>
                                    {visibleItems.length > 0 ? visibleItems.map((item) => (
                                        <DrowRow
                                            key={item.id || Math.random()}
                                            hideActions={props.hideActions}
                                            hideGroupActions={props.hideGroupActions || false}
                                            columns={props.columns}
                                            data={item}
                                            actions={actions}
                                            tableAction={tableAction}
                                            selectedItems={props.selectedItems}
                                            setSelectedItems={props.setSelectedItems}
                                        />
                                    )) : <DrowRow itemsCount={itemsCountNumber} columns={props.columns} text={t.emptyItems} actions={actions} tableAction={tableAction} />}
                                    </tbody>
                                </table>
                            )}

                            {viewMode === "blocks" && (
                                <div
                                    className="row g-3 p-3"
                                    style={{ padding: isDesktop ? "1rem" : "0px", margin: 0 }}
                                >
                                    {visibleItems.length > 0 ? visibleItems.map((item) => (
                                        <div className={cardColumnClass} key={item.id || Math.random()}>
                                            {cardRenderer(item, { renderActions, actions, tableAction })}
                                        </div>
                                    )) : (
                                        <div className="col-12">
                                            <div className="text-center text-muted py-4">{t.emptyItems}</div>
                                        </div>
                                    )}
                                </div>
                            )}

                            <ul className="nav nav-pills p-3 mb-3 rounded align-items-center card flex-row">
                                <li className="nav-item d-flex gap-2 align-items-center">
                                    {!props.hideGroupActions && viewMode === "table" && (
                                        <ActionsDropDown title={t.actions} data={props.data} actions={multiActions} tableAction={tableAction} />
                                    )}
                                    {!props.hideGroupActions && props.groupActionsInBlocks && viewMode === "blocks" && actions.length > 0 && visibleItems.length > 0 && (
                                        <div className="d-flex gap-2 flex-wrap">
                                            {actions.map((action) => (
                                                <button
                                                    key={action.name}
                                                    type="button"
                                                    className="btn btn-light border shadow-sm"
                                                    title={action.label}
                                                    onClick={() => tableAction?.(action.name, props.data || {})}
                                                >
                                                    <i className={action.icon || "ti ti-dots"}></i>
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </li>
                                <li className="nav-item ms-auto">
                                    <div className="d-flex align-items-center justify-content-end py-1">
                                        <p className="mb-0 fs-2">{t.rowsPerPage}</p>

                                        <select value={itemsCountNumber} className="form-select w-auto ms-0 ms-sm-2 me-8 me-sm-4 py-1 pe-7 ps-2 border-0" aria-label="Default select example" onChange={(event) => {
                                            const page = 1
                                            const newItemsCount = parseInt(event.target.value, 10)

                                            setItemsCount(newItemsCount);
                                            AppContext.rows_per_page=newItemsCount;
                                            AppContext.pages[props.object] = {...AppContext.pages[props.object], pageNum: page}

                                            //socket.emit(`${props.object}:list`, {token: AppContext.user.token, page: page, items_count: itemsCount, ...props.searchData, ...props.filters});


                                            search({key: "Enter", page: page, items_count: newItemsCount})

                                            //props.setPageNum(page)
                                        }}>

                                            {itemsCountPerTable.map(item => {
                                                //const selected = (item == itemsCount ? "selected" : "")
                                                return (
                                                    <option value={item}>{item}</option>
                                                )
                                            })}
                                        </select>
                                        <p className="mb-0 fs-2">{props.data.rowsCount < 1 ? 0 : fromRowsCount}–{toRowsCount} {t.rangeOf} {props.data.rowsCount}</p>
                                        <nav aria-label="...">
                                            <ul className="pagination justify-content-center mb-0 ms-8 ms-sm-9">
                                                <li className="page-item p-1">
                                                    <a className="page-link border-0 rounded-circle text-dark fs-6 round-32 d-flex align-items-center justify-content-center"
                                                       href="javascript:void(0)" onClick={() => {
                                                        var page = props.pageNum - 1
                                                        if (page < 1) return;
                                                        AppContext.pages[props.object] = {...AppContext.pages[props.object], pageNum: page}

                                                        search({key: "Enter", page: page})

                                                        //socket.emit(`${props.object}:list`, {token: AppContext.user.token, page: page, items_count: itemsCount, ...props.searchData, ...props.filters});
                                                        //props.setSelectedItems({})
                                                        //props.setResponse({})
                                                        //props.setPageNum(page)
                                                    }}><i className="ti ti-chevron-left"></i></a>
                                                </li>
                                                <li className="page-item p-1">
                                                    <a className="page-link border-0 rounded-circle text-dark fs-6 round-32 d-flex align-items-center justify-content-center"
                                                       href="javascript:void(0)" onClick={() => {

                                                        if (props.pageNum * itemsCountNumber + 1  > props.data.rowsCount) return ;

                                                        const page = props.pageNum + 1

                                                        AppContext.pages[props.object] = {...AppContext.pages[props.object], pageNum: page}
                                                        search({key: "Enter", page: page})

                                                        //socket.emit(`${props.object}:list`, {token: AppContext.user.token, page: page, items_count: itemsCount, ...props.searchData, ...props.filters});
                                                        //props.setSelectedItems({})
                                                        //props.setResponse({})
                                                        //props.setPageNum(page)
                                                    }}><i className="ti ti-chevron-right"></i></a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export  default  Table;
